import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check if user is logged in on mount
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
    }
  }, []);

  const accounts = {
    'elonmusk': { password: 'buggy535!!', brandName: '라이크존' },
    'likezone': { password: 'buggy535!!', brandName: '주식회사 라이크존' },
    'traderb': { password: 'buggy535!!', brandName: '주식회사 픽앤홈' },
    'betweeninc': { password: 'buggy535!!', brandName: '주식회사 비투윈' }
  };

  const login = (username, password) => {
    const account = accounts[username];
    if (account && account.password === password) {
      const userData = { username, brandName: account.brandName };
      setUser(userData);
      setIsAuthenticated(true);
      localStorage.setItem('user', JSON.stringify(userData));
      return true;
    }
    return false;
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
